import { Location, matchPath } from "react-router-dom";
import { breadcrumbsSubdestinationMap, subdestinationMap } from "../components/RootLayout/RootLayoutModels";

export const matchPathInMap = (map: { [key: string]: string }, pathname: string) => {
  return Object.keys(map).find((item) => !!matchPath(item, pathname));
}

/** 
 * The AppBarComp should be showing menu for top-level destinations (ex. my-profile),
 * back-arrow for sub destinations (ex. address-change)
 * and breadcrmb menu for multi-level sub destinations (ex. audit reports)
 */
export const getNavIcon = (location: Location<any>) => {
  const subdestination = matchPathInMap(subdestinationMap, location.pathname);
  const breadcrumbsSubdestination = matchPathInMap(breadcrumbsSubdestinationMap, location.pathname);
  const isSubdestination = subdestination && !breadcrumbsSubdestination;
  const isBreadcrumbsSubdestinationMap = breadcrumbsSubdestination != null;
  if (isSubdestination) return "back";
  if (isBreadcrumbsSubdestinationMap) return "breadcrumbs";
  return "menu";
};
